import { AddAnchorVwapButtonComponent } from "./components/menu/add-anchor-vwap-button.component";
import { AddComparisonSymbolsButtonComponent } from "./components/menu/add-comparison-symbols-button.component";
import { AddIndicatorsButtonComponent } from "./components/menu/add-indicators-button.component";
import { AddPriceAlertButtonComponent } from "./components/menu/add-price-alert-button.component";
import { BuyButtonComponent } from "./components/menu/buy-button.component";
import { CameraScrenshotComponent } from "./components/menu/camera-screnshot.component";
import { ChartTypeComponent } from "./components/menu/chart-type.component";
import { HeartStatusComponent } from "./components/menu/heart-status.component";
import { HighChartIndicatorsComponent } from "./components/menu/highchart-indicators.component";
import { SellButtonComponent } from "./components/menu/sell-button.component";
import { SymbolLookupComponent } from "./components/menu/symbol-lookup.component";
import { TimeframeIconComponent } from "./components/menu/timeframe-icon.component";
import { ToolIconComponent } from "./components/menu/tool-icon.component";
import { IChartContainer } from "./models/base/chart-container.interface";

export class TiChartMenuContainer {
    private tiChartContainer: IChartContainer;
    private toolIconComponent: ToolIconComponent;
    private element: HTMLElement;

    public displayTools = false;
    public displayTimeframe = false;
    public displayChartType = false;
    public displayIndicator = false;

    constructor(el: HTMLElement, tiChartContainer: IChartContainer) {
        this.element = el;
        this.tiChartContainer = tiChartContainer;

        if (this.tiChartContainer.marketingWebChartMode || this.tiChartContainer.pnpMode) {    
            this.createTimeframeIconComponent();
            this.onBodyClick();
            return;
        }

        this.createChartTypeComponent();
        this.createSymbolLookupComponent();
        this.createHighChartIndicatorsComponent();
        this.createToolIconComponent();
        this.createTimeframeIconComponent();
        this.createBuyButtonComponent();
        this.createSellButtonComponent();
        this.createAddIndicatorsButtonComponent();
        this.createAddPriceAlertButtonComponent();
        this.createAddAnchorVwapButtonComponent();
        this.createAddComparisonSymbolsButtonComponent();
        this.createHeartStatusComponent();
        this.createCameraScreenshotComponent();
        this.onBodyClick();
    }

    private createChartTypeComponent() {
        this.element.querySelectorAll<HTMLElement>('.chart-type').forEach((el: HTMLElement) => {
            const chartTypeComponent = new ChartTypeComponent(el, this.tiChartContainer, this);
            this.tiChartContainer.components.push(chartTypeComponent);
        });
    }

    private createHighChartIndicatorsComponent() {
        this.element.querySelectorAll<HTMLElement>('.indicator').forEach((el: HTMLElement) => {
            const highChartsIndicatorsComponent = new HighChartIndicatorsComponent(el, this, this.tiChartContainer);
            this.tiChartContainer.components.push(highChartsIndicatorsComponent);
        });
    }

    private createSymbolLookupComponent() {
        const symbolLookupComponent = new SymbolLookupComponent(this.tiChartContainer);
        this.tiChartContainer.components.push(symbolLookupComponent);
    }

    private createToolIconComponent() {
        this.toolIconComponent = new ToolIconComponent(this, this.tiChartContainer);
        this.tiChartContainer.components.push(this.toolIconComponent);
    }

    private createTimeframeIconComponent() {
        this.element.querySelectorAll<HTMLElement>('.controls .time').forEach((el: HTMLElement) => {
            const timeframeComponent = new TimeframeIconComponent(el, this, this.tiChartContainer);
            this.tiChartContainer.components.push(timeframeComponent);
        });
    }

    private createBuyButtonComponent() {
        this.element.querySelectorAll<HTMLElement>('.buy-sell-buttons-container .buy').forEach((el: HTMLElement) => {
            this.tiChartContainer.components.push(new BuyButtonComponent(el, this.tiChartContainer));
        });
    }

    private createSellButtonComponent() {
        this.element.querySelectorAll<HTMLElement>('.buy-sell-buttons-container .sell').forEach((el: HTMLElement) => {
            this.tiChartContainer.components.push(new SellButtonComponent(el, this.tiChartContainer));
        });
    }

    private createAddIndicatorsButtonComponent() {
        this.element.querySelectorAll<HTMLElement>('.add-indicators-button').forEach((el: HTMLElement) => {
            this.tiChartContainer.components.push(new AddIndicatorsButtonComponent(el, this.tiChartContainer));
        });
    }

    private createAddPriceAlertButtonComponent() {
        this.element.querySelectorAll<HTMLElement>('.add-price-alert-button').forEach((el: HTMLElement) => {
            this.tiChartContainer.components.push(new AddPriceAlertButtonComponent(el, this.tiChartContainer));
        });
    }

    private createAddAnchorVwapButtonComponent() {
        this.element.querySelectorAll<HTMLElement>('.add-anchor-vwap-button').forEach((el: HTMLElement) => {
            this.tiChartContainer.components.push(new AddAnchorVwapButtonComponent(el, this.tiChartContainer));
        });
    }

    private createAddComparisonSymbolsButtonComponent() {
        this.element.querySelectorAll<HTMLElement>('.add-comparion-symbols-button').forEach((el: HTMLElement) => {
            this.tiChartContainer.components.push(new AddComparisonSymbolsButtonComponent(el, this.tiChartContainer));
        });
    }

    private createHeartStatusComponent() {
        this.element.querySelectorAll<HTMLElement>('.heart-status-button').forEach((el: HTMLElement) => {
            this.tiChartContainer.components.push(new HeartStatusComponent(el, this.tiChartContainer));
        });
    }

    private createCameraScreenshotComponent() {
        this.element.querySelectorAll<HTMLElement>('.camera-screenshot-button').forEach((el: HTMLElement) => {
            this.tiChartContainer.components.push(new CameraScrenshotComponent(el, this.tiChartContainer));
        });
    }

    public toggleControls() {
        const tools = this.element.findParents('.main-chart')?.querySelector('.highcharts-stocktools-wrapper');
        if (tools) {
            if (this.displayTools) {
                this.toolIconComponent?.show();
            } else {
                this.toolIconComponent?.hide();
            }
        }

        const timeframe = this.element.querySelector('.controls .time');
        if (timeframe) {
            if (this.displayTimeframe) {
                timeframe.classList.add('active');
            } else {
                timeframe.classList.remove('active');
            }
        }

        const chartType = this.element.querySelector('.controls .chart-type');
        if (chartType) {
            if (this.displayChartType) {
                chartType.classList.add('active');
            } else {
                chartType.classList.remove('active');
            }
        }

        const indicator = this.element.querySelector('.controls .indicator');
        if (indicator) {
            if (this.displayIndicator) {
                indicator.classList.add('active');
            } else {
                indicator.classList.remove('active');
            }
        }
    }

    public closeAllMenuControls() {
        this.displayChartType = false;
        // this.displayTools = false;
        this.displayIndicator = false;
        this.displayTimeframe = false;
        this.toggleControls();
    }

    private onBodyClick() {
        this.tiChartContainer.domEvents.onScreenClick(() => {
            this.closeAllMenuControls();
        });
    }
}